import { useEffect, useState } from "react";
import getBackendURL from "../api/api";
import { request } from "../request";

type FacetValue = {
	label: string;
	value: string;
};

type Facet = {
	key: string;
	label: string;
	values: FacetValue[];
};

export function useGroupFacets(): Facet[] {
	const [values, setValues] = useState<FacetValue[]>([]);

	useEffect(() => {
		let cancelled = false;
		request(getBackendURL("/clowder/get_selectable_groups")).then(({ data }) => {
			if (cancelled) return;
			setValues(data.groups);
		});

		return () => {
			cancelled = true;
		};
	}, []);

	return [{ key: "groups", label: "Groups", values }];
}